import { CommitmentSourcesService_commitmentSourcesServiceGetStopsLatest } from '@festina/life-general-types/life/hooks/CommitmentSourcesStopsService_commitmentSourcesServiceGetStopsLatest'

export const useFetchCommitmentSourcesStopsLatest =
  CommitmentSourcesService_commitmentSourcesServiceGetStopsLatest.useSuspenseQuery
